import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apexRedirectUrl } from "@/lib/hostTenant";

/**
 * Redirect `www.photohawk(-staging).com` → the bare apex (mirrors the app).
 * Tenant scoping is now derived from the host directly (useWorkspace resolves
 * the active workspace from the alias subdomain / custom domain), so the admin
 * routes no longer need to be forwarded through a resolver.
 */
const HostTenantRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const apex = apexRedirectUrl(window.location.hostname, location.pathname, location.search);
    if (apex) window.location.replace(apex);
  }, [location.pathname, location.search]);

  return null;
};

export default HostTenantRedirect;
